import { PROVEEDORES } from '../actions/types';

const initialState = {
    listado: [],
    detalles: null
};

export default (state = initialState, action) => {

    const { type, payload } = action;

    switch ( type ) {
        case PROVEEDORES.BUSCAR:
            return {
                ...state,
                listado: payload
            };

        case PROVEEDORES.DETALLES:
            return {
                ...state,
                detalles: payload
            };

        case PROVEEDORES.ELIMINAR:
            return {
                ...state,
                listado: state.listado.filter( proveedor => proveedor.id !== payload )
            };
        
        default:
            return state;
    }
}